import { ServiceTemplatesAdapter } from '~/services/adapters/service-templates.adapter';

export class ServiceTemplatesService extends ServiceTemplatesAdapter {}
